// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"loading_spinnerContainer__4FgjV","spinner":"loading_spinner__-+7IQ"};